import { useGetManyReference, useRecordContext, useRecordFromLocation } from 'react-admin'

import type { EventRecord } from '@/data/source'

export const useScaleEvents = (scaleRecordId: unknown): EventRecord[] | undefined => {
  const { data } = useGetManyReference<EventRecord>(
    'scale_events',
    {
      target: 'scaleRecordId',
      id: String(scaleRecordId),
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'startTime', order: 'DESC' },
    },
    { enabled: typeof scaleRecordId === 'string' },
  )
  return data
}

export const useEventRecord = (): Partial<EventRecord> | undefined => {
  const fromLocation = useRecordFromLocation()
  const fromContext = useRecordContext<Partial<EventRecord>>()
  if (fromContext) return fromContext
  if (!fromLocation) return undefined
  const { id, ...fields } = fromLocation
  return typeof id === 'string' ? { ...fields, id } : fields
}
